// extracted by mini-css-extract-plugin
export default {"loader":"CpGj4K6tww5IBtl","rotation":"D5gtJuik8RMM5j6"};